import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=ca4c2040&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca4c2040')) {
      api.createRecord('ca4c2040', component.options)
    } else {
      api.reload('ca4c2040', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=ca4c2040&", function () {
      api.rerender('ca4c2040', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2t2QgXHCxwQQP/JS/comp/ErrorMessage.vue"
export default component.exports